import { IImage } from '@eventr/common'
import { AuthImage } from '@eventr/common-storybook'

interface IActivityImageProps {
    images: IImage[]
    isAdvance?: boolean
}

export const ActivityImage = ({ images, isAdvance }: IActivityImageProps) => {
    if (!isAdvance) return null
    if (!images[0]?.url) return null
    return (
        <AuthImage
            margin={'-8px -8px 0px -8px'}
            height={'77px'}
            style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
            src={images[0]?.url}
        ></AuthImage>
    )
}
